/** This file will have the authentication failure redirect page and link to be shown to the user, when  logging happens using Premier*/

// export const PREMIER_AUTHFAILURE_REDIRECT = {
//     productConfigurator: 'browse/details',
//     cart: 'errorPage'
//   };


//   export const PREMIER_AUTHFAILURE_LINKURL = {
//     buy_and_manage: '',
//     buy_only: '',
//     manage_only: 'no_permissions',
//     none: 'no_permissions'
//   };

//   // tslint:disable-next-line:max-line-length
//   export const PREMIER_AUTHFAILURE_MESSAGE = 'You don\'t have permissions to access the page, continue to remain in this or go to <a href="{pageName}">{pageName}</a>. Please contact your TCM for more Details';

export const ADDP_PERMISSION_MAPPING_FNABC = {
    // tslint:disable-next-line:max-line-length
    NotEligible: { logonurl: 'errorPage/408', message: 'Your company isn\'t eligible to use the program. For help, contact your AT&T representative. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },
    NoPermission: { logonurl: 'errorPage/408', message: 'Company is eligible, you lack permssions = can errorPage/408 only' },
    Read_NoFAN: { logonurl: 'errorPage/408', message: 'Company is eligible, you have Read Only permssions = use hamburger menu to navigate' },
    Read_SomeFAN: { logonurl: 'errorPage/408', message: 'Company is eligible, contact your lead TCM for Sign-Up' },
    Read_AllFAN: { logonurl: 'manage', message: null },
    Partial_NoFAN: { logonurl: 'errorPage/408', message: 'Company is eligible, you have Read Only permssions = use hamburger menu to navigate' },
    Partial_SomeFAN: { logonurl: 'errorPage/408', message: 'Company is eligible, contact your lead TCM for Sign-Up' },
    Partial_AllFAN: { logonurl: 'manage', message: null },
    Full_NoFAN: { logonurl: 'signup', message: null },
    Full_SomeFAN: { logonurl: 'signup', message: null },
    Full_AllFAN: { logonurl: 'manage', message: null },

    // Newly added -> ADDPAUTHORITY_FANSIGNEDUPSTUS mapping for landing page on check eligibility
    // tslint:disable-next-line:max-line-length
    READ_ONLY_ALL: { logonurl: 'errorPage/408', message: 'Your access to the program is read only. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },
    READ_ONLY_SOME: { logonurl: 'errorPage/408', message: 'Your access to the program is read only. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },
    // tslint:disable-next-line:max-line-length
    READ_ONLY_NONE: { logonurl: 'errorPage/408', message: 'Your access to the program is read only. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },
    READ_ONLY_NotEligible: { logonurl: 'errorPage/408', message: "You don't have any eligible accounts. For help, contact your representative.  " },
    READ_ONLY_Error: { logonurl: 'errorPage/408', message: 'Your access to the program is read only. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },

    PARTIAL_ALL: { logonurl: 'manageInventory', message: null },
    PARTIAL_SOME: { logonurl: 'manageInventory', message: null },
    // tslint:disable-next-line:max-line-length
    PARTIAL_NONE: { logonurl: 'errorPage/408', message: 'You have only partial access to the program. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },
    // tslint:disable-next-line:max-line-length
    PARTIAL_NotEligible: { logonurl: 'errorPage/408', message: "You don't have any eligible accounts. For help, contact your representative.  " },
    PARTIAL_Error: { logonurl: 'errorPage/408', message: 'You have only partial access to the program. For help, contact your administrator. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.' },

    FULL_ALL: { logonurl: 'manageInventory', message: null },
    FULL_NONE: { logonurl: 'welcome', message: null },
    FULL_SOME: { logonurl: 'productselection', message: null },
    // tslint:disable-next-line:max-line-length
    FULL_NotEligible: { logonurl: 'errorPage/408', message: "You don't have any eligible accounts. For help, contact your representative.  " },
    FULL_Error: { logonurl: 'dashboard', message: null },
    // tslint:disable-next-line:max-line-length
    NONE_ALL: {
        logonurl: 'errorPage/408',
        message: ' For help with program access, ask your representative to verify your permissions for this account. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.'
    },
    NONE_SOME: {
        logonurl: 'errorPage/408',
        message: ' For help with program access, ask your representative to verify your permissions for this account. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.'
    },
    // tslint:disable-next-line:max-line-length
    NONE_NONE: {
        logonurl: 'errorPage/408',
        message: 'For help with account access, ask your representative to verify your permissions for this account. Or, call us at 800.574.7000, Monday through Friday, 8 a.m. to 10 p.m. ET.'
    },
};
